import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBackOutline, IoSaveOutline, IoCodeSlashOutline } from 'react-icons/io5';
import Navbar from '../lab/Navbar';
import labService from '../lab/labService';
import '../wallet/css/ManageLicences.css';

const CreateModelAdmin = () => {
  const navigate = useNavigate();
  const [endpoints, setEndpoints] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  const [formData, setFormData] = useState({
    model_name: '',
    version_name: 'v1.0.0',
    endpoint_type: '',
    algorithm_type: 'QSAR_nQTb',
    response_class: '',
    model_category: 'human toxicity',
    method_type: 'classification',
    model_price: 1,
    model_exec_path: './ml_models/',
    scaler_exec_path: './ml_models/',
    data_path: './ml_models/',
    descriptors: '{\n  "descriptors": [],\n  "descriptors_units": []\n}',
    model_details: '{\n  "endpoint_desc": "",\n  "statistics": {},\n  "model_applicability": ""\n}'
  });

  useEffect(() => {
    const fetchEndpoints = async () => {
      const token = JSON.parse(localStorage.getItem('user'))?.access;
      try {
        const res = await labService.getEndpoints(token);
        setEndpoints(res.data);
      } catch (e) { console.error(e); }
    };
    fetchEndpoints();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    const token = JSON.parse(localStorage.getItem('user'))?.access;

    try {
      const payload = {
        ...formData,
        descriptors: JSON.parse(formData.descriptors),
        model_details: JSON.parse(formData.model_details),
        model_price: parseFloat(formData.model_price)
      };

      await labService.createModelAdmin(payload, token);
      navigate('/manage-models');
    } catch (error) {
      console.error(error);
      alert("Error saving model. Check JSON format or required fields.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className='lab-container'>
      <Navbar />
      <div className="manage-licenses-container" style={{ padding: '40px' }}>
        <header style={{ display: 'flex', alignItems: 'center', marginBottom: '30px', gap: '20px' }}>
          <IoArrowBackOutline
            className="icon-action-danger"
            style={{ fontSize: '30px', color: '#1B4480', cursor: 'pointer' }}
            onClick={() => navigate(-1)}
          />
          <h2 className='h2-title' style={{ margin: 0 }}>Create New ML Model</h2>
        </header>

        <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>

          {/* Kolumna lewa: Basic Information & Technical Paths */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>

            {/* Basic Information */}
            <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
              <h3 style={{ color: '#1B4480', marginTop: 0, marginBottom: '20px' }}>Basic Information</h3>

              <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <label style={{ flex: '0 0 180px', margin: 0, fontWeight: '500' }}>Model Name</label>
                <input className="search-input" style={{ flex: 1, boxSizing: 'border-box', paddingLeft: '15px' }} value={formData.model_name} onChange={e => setFormData({ ...formData, model_name: e.target.value })} required />
              </div>

              <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <label style={{ flex: '0 0 180px', margin: 0, fontWeight: '500' }}>Endpoint (Core)</label>
                <select className="search-input" style={{ flex: 1, boxSizing: 'border-box', paddingLeft: '15px', height: '45px' }} value={formData.endpoint_type} onChange={e => setFormData({ ...formData, endpoint_type: e.target.value })} required>
                  <option value="">Select Endpoint...</option>
                  {endpoints.map(ep => <option key={ep.id} value={ep.id}>{ep.endpoint_name}</option>)}
                </select>
              </div>

              <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <label style={{ flex: '0 0 180px', margin: 0, fontWeight: '500' }}>Version</label>
                <input className="search-input" style={{ flex: 1, boxSizing: 'border-box', paddingLeft: '15px' }} value={formData.version_name} onChange={e => setFormData({ ...formData, version_name: e.target.value })} />
              </div>

              <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <label style={{ flex: '0 0 180px', margin: 0, fontWeight: '500' }}>Price (Coins)</label>
                <input type="number" className="search-input" style={{ flex: 1, boxSizing: 'border-box', paddingLeft: '15px' }} value={formData.model_price} onChange={e => setFormData({ ...formData, model_price: e.target.value })} />
              </div>
            </div>

            {/* Technical Paths */}
            <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
              <h3 style={{ color: '#1B4480', marginTop: 0, marginBottom: '20px' }}>Technical Paths</h3>

              <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <label style={{ flex: '0 0 180px', margin: 0, fontWeight: '500' }}>Model Exec Path (.pickle)</label>
                <input className="search-input" style={{ flex: 1, boxSizing: 'border-box', paddingLeft: '15px', fontSize: '13px' }} value={formData.model_exec_path} onChange={e => setFormData({ ...formData, model_exec_path: e.target.value })} />
              </div>

              <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <label style={{ flex: '0 0 180px', margin: 0, fontWeight: '500' }}>Scaler Path</label>
                <input className="search-input" style={{ flex: 1, boxSizing: 'border-box', paddingLeft: '15px', fontSize: '13px' }} value={formData.scaler_exec_path} onChange={e => setFormData({ ...formData, scaler_exec_path: e.target.value })} />
              </div>

              <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <label style={{ flex: '0 0 180px', margin: 0, fontWeight: '500' }}>Data Source Path (.xlsx)</label>
                <input className="search-input" style={{ flex: 1, boxSizing: 'border-box', paddingLeft: '15px', fontSize: '13px' }} value={formData.data_path} onChange={e => setFormData({ ...formData, data_path: e.target.value })} />
              </div>
            </div>

          </div>

          {/* Kolumna prawa: JSON Configuration & Przyciski */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

            {/* JSON Configuration */}
            <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #e2e8f0', flex: 1 }}>
              <h3 style={{ color: '#1B4480', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                <IoCodeSlashOutline /> JSON Configuration
              </h3>
              <p style={{ fontSize: '12px', color: '#718096', marginBottom: '20px' }}>Paste the JSON structure for descriptors and details here.</p>

              <div className="form-group" style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '20px' }}>
                <label style={{ flex: '0 0 180px', margin: 0, marginTop: '10px', fontWeight: '500' }}>Descriptors JSON</label>
                <textarea
                  style={{ flex: 1, boxSizing: 'border-box', height: '140px', fontFamily: 'monospace', fontSize: '12px', padding: '10px', borderRadius: '6px', border: '1px solid #e2e8f0', resize: 'vertical' }}
                  value={formData.descriptors}
                  onChange={e => setFormData({ ...formData, descriptors: e.target.value })}
                />
              </div>

              <div className="form-group" style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                <label style={{ flex: '0 0 180px', margin: 0, marginTop: '10px', fontWeight: '500' }}>Model Details & Stats</label>
                <textarea
                  style={{ flex: 1, boxSizing: 'border-box', height: '220px', fontFamily: 'monospace', fontSize: '12px', padding: '10px', borderRadius: '6px', border: '1px solid #e2e8f0', resize: 'vertical' }}
                  value={formData.model_details}
                  onChange={e => setFormData({ ...formData, model_details: e.target.value })}
                />
              </div>
            </div>

            {/* Przyciski akcji */}
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', marginTop: '10px' }}>
              <button type="button" className="btn btn-neutral" onClick={() => navigate(-1)} style={{ padding: '12px 30px' }}>Cancel</button>
              <button type="submit" className="btn btn-primary" style={{ padding: '12px 40px', display: 'flex', alignItems: 'center', gap: '8px' }} disabled={isSaving}>
                <IoSaveOutline size="20px" /> {isSaving ? 'Saving...' : 'Create Model'}
              </button>
            </div>
          </div>

        </form>
      </div>
    </div>
  );
};

export default CreateModelAdmin;
